import { render, staticRenderFns } from "./RolePermissionsTable.vue?vue&type=template&id=42a24ca4&"
import script from "./RolePermissionsTable.vue?vue&type=script&lang=ts&"
export * from "./RolePermissionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RolePermissionsTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports